import { useCurrentUserStore } from '@/stores/currentUser.ts';
import type { MenuGroup } from '@/components/shared/sidebar/sidebar_menu';
import { computed } from 'vue';

export const useAdminSidebar = () => {
  const currentUserStore = useCurrentUserStore();

  const defaultGroups = (): MenuGroup[] => [
    {
      show: true,
      items: [
        {
          title: 'Teams',
          url: '/admin/teams?sort=created&order=desc&status=Active',
          icon: 'home',
          show: true,
        },
        {
          title: 'Budget Update Requests',
          url: '/admin/budget_requests?sort=created&order=desc&status=Pending',
          icon: 'bookmark',
          show: true,
        },
        {
          title: 'Customer Invites',
          url: '/admin/customer_invites?sort=created_at&order=desc',
          icon: 'users',
          show: true,
        },
      ],
    },
  ];

  const agentGroups = (): MenuGroup[] => [];

  const menuGroups = computed(() => (currentUserStore.isAgent() ? agentGroups() : defaultGroups()));

  return { menuGroups };
};
